var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:_vm.getClass()},[_vm._v(_vm._s(_vm._f("translate")('report-of-sickness.states.' + _vm.status)))])
}
var staticRenderFns = []

export { render, staticRenderFns }